<template lang="pug">
.coupon-container( @click="$emit('click')" :class= 'colors' )
  .title {{info.name}}
  .subtitle
    span.text() {{info.originPrice}} 元券包
    .text-ticket() 含{{info.amount}}张券
  .price
    span.above-money
      span.money ¥
      span.current {{info.purchasePrice}}
    span.under-money
      span.money.gray ¥
      del.del.origin-price.gray() {{info.originPrice}}
    .buy 购买
</template>

<script>

export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => ({
        name: '周年庆APP单车券包',
        subtitle: '',
        originPrice: '12',
        purchasePrice: '6.8',
        amount: '2',
      }),
    },
  },
  computed: {
    colors() {
      return this.active ? 'bike' : 'moped';
    },
  },
  methods: { },
};
</script>

<style lang="less" scoped>
.bike {
  background-image: url('https://m.hellobike.com/resource/AppPlatformH5/card-for-app/m5M7NcFjPQH1Gb4R1YXxO.png');
}

.moped {
  background-image: url('https://m.hellobike.com/resource/AppPlatformH5/card-for-app/GmcRBZTKnzq85Wytq7hYO.png');
}

.gray {
  color: #879099 !important;
}

.money {
  height: 0.17rem;
  font-size: 0.12rem;
  font-weight: 500;
  color: #ff5103;
  line-height: 0.17rem;
}

.coupon-container {
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: flex-start;
  justify-content: center;
  width: 1.46rem;
  height: 1.26rem;
  // background: linear-gradient(136deg, #fff3d4 0%, #ffe6ba 100%);
  background-size: 100%;
  border-radius: 0.08rem;
  overflow: hidden;
  box-sizing: border-box;
  border: 2px solid white;

  .title {
    position: absolute;
    top: 0.1rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.13rem;
    font-weight: 400;
    color: #242729;
    text-align: center;
    max-width: 1.2rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .price {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    position: absolute;
    top: 0.85rem;
    padding-left: 0.08rem;

    .above-money {
      position: absolute;
      top: -0.05rem;
      left: 0.08rem;
    }

    .under-money {
      position: absolute;
      left: 0.08rem;
      top: 0.12rem;
    }

    .buy {
      width: 0.53rem;
      height: 0.27rem;
      background: linear-gradient(180deg, #ffa88a 0%, #ff5103 100%);
      border-radius: 0.14rem;
      font-size: 0.12rem;
      font-weight: 500;
      color: #fff;
      text-align: center;
      line-height: 0.27rem;
      position: absolute;
      right: 0.08rem;
      top: 0.01rem;
    }
  }

  .subtitle {
    position: absolute;
    top: 0.45rem;
    margin-left: 0.08rem;
    display: flex;
    align-items: center;

    .text {
      font-size: 0.13rem;
      padding-left: 0.08rem;
      font-weight: 400;
      color: #242729;
      line-height: 0.13rem;
    }

    .text-ticket {
      margin-left: 0.05rem;
      height: 0.16rem;
      border-radius: 0.04rem;
      border: 1px solid #ff9a8b;
      font-size: 0.1rem;
      font-weight: 400;
      color: #ff5103;
      line-height: 0.13rem;
      padding: 0.01rem 0.03rem;
    }
  }

  .origin-price {
    font-size: 0.12rem;
    font-weight: 400;
    color: #879099;
    line-height: 0.17rem;
  }

  .del {
    color: #879099;
  }

  .current {
    font-size: 0.2rem;
    font-weight: 500;
    color: #ff5103;
    line-height: 0.16rem;
  }

  .icon {
    position: absolute;
    top: -0.01rem;
    right: -0.01rem;
    height: 0.17rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(270deg, #ff1217 0%, #ff714f 100%);
    border-radius: 0 0.01rem 0 0.08rem;
    font-size: 0.1rem;
    padding: 0 0.04rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
  }
}

</style>
